// extracted by mini-css-extract-plugin
export var downArrow = "_7m-0";
export var infoTooltipIcon = "_7m-3";
export var label = "_7m-1";
export var optionCard = "_7m-4";
export var upArrow = "_7m-2";